
export default function LanguageSupport() {
  const languages = [
    { name: 'C/C++', icon: 'ri-code-s-slash-line' },
    { name: 'Java', icon: 'ri-java-line' },
    { name: '.NET', icon: 'ri-microsoft-line' },
    { name: 'Python', icon: 'ri-terminal-box-line' },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            多语言支持
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            使用您熟悉的编程语言进行开发
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {languages.map((language) => (
            <div
              key={language.name}
              className="bg-gray-50 p-8 rounded-xl text-center hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className={`${language.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">
                {language.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
